import type { SxProps, Theme } from '@mui/material/styles';
import { ColorScheme, theme } from './theme';
import { FONT_ENUM } from '../types/global/fonts.types';

/** Work Profile column section labels: uppercase, highlight color, compact. */
export function workProfileSectionTitleSx(themeStyle: ColorScheme): SxProps<Theme> {
    return {
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        fontFamily: FONT_ENUM.MAIN_BOLD,
        color: theme[themeStyle].highlight,
        textAlign: 'left',
    };
}
